import React from 'react';
import { PromoCampaign } from '../types';

interface PromoBannerProps {
  campaign: PromoCampaign;
  className?: string;
}

/**
 * The offer banner shown above the sign-in and onboarding forms for a golfer who arrived through a
 * promo campaign link, e.g. "End of Season Fun — Try out CaddieSight for two months."
 */
const PromoBanner: React.FC<PromoBannerProps> = ({ campaign, className }) => (
  <aside className={`promo-banner${className ? ` ${className}` : ''}`} aria-label={`${campaign.name} offer`}>
    <i className="pi pi-gift promo-banner__icon" aria-hidden="true" />
    <div className="promo-banner__copy">
      <strong className="promo-banner__title">{campaign.name}</strong>
      {campaign.message ? <span className="promo-banner__message">{campaign.message}</span> : null}
      <span className="promo-banner__detail">
        {campaign.trialDays} days free · No payment needed
      </span>
    </div>
  </aside>
);

export default PromoBanner;
